import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandleAlignedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 18c5 0 6-12 9-12s4 12 9 12" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 6,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 6h10",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 6,
			r: 1.5,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 6,
			r: 1.5,
			strokeWidth: 1.5
		})
	]
});
export default SvgHandleAlignedIcon;
